module.exports = __webpack_public_path__ + "img/clube6.200b22b7.jpeg";